import { ScoreOverTimeChartPoints } from '../../types';
import ContentWithLabel from '../shared/ContentWithLabel';
import ScoreOverTimeChart from '../shared/ScoreOverTimeChart';

type Props = {
  scores: ScoreOverTimeChartPoints[];
  lowThreshold: number;
  mediumThreshold: number;
};

const HighScoreOverTime = ({
  scores,
  lowThreshold,
  mediumThreshold,
}: Props) => (
  <ContentWithLabel variant="big" title="Health Score over time">
    <ScoreOverTimeChart
      height={95}
      scores={scores}
      lowThreshold={lowThreshold}
      mediumThreshold={mediumThreshold}
      hideXAxis={false}
    />
  </ContentWithLabel>
);

export default HighScoreOverTime;
